import React, { useEffect, useState } from "react";
import MountainImg from "../assets/media/rishab_sorted_about_1.jpg";
import RiverImg from "../assets/media/rishab_sorted_about_2.jpg";
import { Link } from "react-router-dom";
import AboutUsAPI from "../api/AboutUsAPI";

const AboutPreview = ({ data }) => {

  return (
    <section className="custom-about-preview-section" style={{ marginBottom: "30px" }}>
      <div className="container-fluid d-flex justify-content-center px-0">
        <div className="row">
          <div className="col-12 px-0">
            <h2 className="mb-3 fs-3 fw-bold custom-about-preview-header">About Us</h2>
          </div>
          <div className="custom-about-preview-content col-md-6 col-lg-6 col-xl-5 p-0 position-relative">

            <p
              className="pt-2 px-0"
              style={{
                textAlign: "justify",
                width: "100%",
                overflow: "hidden",
              }}
              dangerouslySetInnerHTML={{ __html: data }}
            ></p>
            <div className=" ms-3 ms-0">
              <Link to="/alltrips">All trips</Link>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-xl-7 pe-0">
            <div className="row">
              <div className="col-lg-6 pt-5 about-preview-images overflow-hidden">
                <img
                  src={MountainImg}
                  alt="Mountain"
                  className="img-fluid rounded-2"
                />
              </div>
              <div className="col-lg-6 pt-2 about-preview-images overflow-hidden">
                <img src={RiverImg} alt="River" className="img-fluid rounded-2" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section >
  );
}

export default AboutPreview;
